import { c as _c } from "react/compiler-runtime";
import type { CreateWaveOutcomeConfigWinner, CreateWaveOutcomeConfigWinnersCreditValueType, CreateWaveOutcomeType } from "@/types/waves.types";
import CreateWaveOutcomesWinnersRow from "./CreateWaveOutcomesWinnersRow";
export default function CreateWaveOutcomesWinnersRows(t0) {
  const $ = _c(22);
  const {
    creditValueType,
    winners,
    isError,
    outcomeType,
    setWinners
  } = t0;
  let t1;
  if ($[0] !== setWinners || $[1] !== winners) {
    t1 = index => {
      setWinners(winners.filter((_, i) => i !== index));
    };
    $[0] = setWinners;
    $[1] = winners;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const removeWinner = t1;
  let t2;
  if ($[3] !== setWinners || $[4] !== winners) {
    t2 = t3 => {
      const {
        value,
        index: index_0
      } = t3;
      const newWinners = [...winners];
      newWinners[index_0] = {
        value
      };
      setWinners(newWinners);
    };
    $[3] = setWinners;
    $[4] = winners;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const onWinnerValueChange = t2;
  let t3;
  if ($[6] !== creditValueType || $[7] !== isError || $[8] !== onWinnerValueChange || $[9] !== outcomeType || $[10] !== removeWinner || $[11] !== winners) {
    let t4;
    if ($[13] !== creditValueType || $[14] !== isError || $[15] !== onWinnerValueChange || $[16] !== outcomeType || $[17] !== removeWinner || $[18] !== winners.length) {
      t4 = (winner, i_0) => <CreateWaveOutcomesWinnersRow key={i_0} i={i_0} winnersCount={winners.length} creditValueType={creditValueType} winner={winner} isError={isError} outcomeType={outcomeType} removeWinner={removeWinner} onWinnerValueChange={onWinnerValueChange} />;
      $[13] = creditValueType;
      $[14] = isError;
      $[15] = onWinnerValueChange;
      $[16] = outcomeType;
      $[17] = removeWinner;
      $[18] = winners.length;
      $[19] = t4;
    } else {
      t4 = $[19];
    }
    t3 = winners.map(t4);
    $[6] = creditValueType;
    $[7] = isError;
    $[8] = onWinnerValueChange;
    $[9] = outcomeType;
    $[10] = removeWinner;
    $[11] = winners;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[20] !== t3) {
    t4 = <div className="tw-space-y-3">{t3}</div>;
    $[20] = t3;
    $[21] = t4;
  } else {
    t4 = $[21];
  }
  return t4;
}